<template>
	<div>
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<!-- 搜索主体 -->
		<div class="searchPage">
			<!-- 中间主体 -->
			<div class="searchContent">
				<div class="pt-3 pl-3">
					<p>您搜索的关键词为:<span style="color: #C32A1A;font-weight: bold;">{{condition.keyValue}}</span></p>
					<p>共搜索到{{goodsList.length}}条结果</p>
				</div>
				<!-- 商品列表 -->
				<div class="goodsList">
					<div v-for="(item,index) in goodsList" class="d-inline-block hot_card_list ml-5 mb-3" :key="index"
						 style="cursor: pointer;">
						<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :price="item.chargeAmount"
						@click="goodsShow(item.id)"></show-card>
					</div>
				</div>
			</div>
		</div>
		<div>
			<Footer :bgColor="'#fafafa'" :border="true"></Footer>
		</div>
	</div>
</template>

<script>
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import showCard from '../showCard/showCard.vue'
	import Footer from '@/components/footer/footer.vue'
	export default{
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			showCard,
			Footer
		},
		data() {
			return {
				goodsList:[],
				paging: {currPage: 1, everySize: 12, allNum: 0},
				//检索条件
				condition: {
					type:'',
					keyValue:''
				},
				mbx:'',
				mbxLink:''
			}
		},
		mounted() {
			this.condition.type = this.$route.query.type
			this.condition.keyValue = this.$route.query.keyValue
			this.mbx = this.condition.type == 'patent' ? '专利交易' : '商标交易'
			this.mbxLink = this.condition.type == 'patent' ? '/patent' : '/brand'
			this.getSearchGoods()
		},
		watch: {
			'$route'(to, from) {
				this.condition.type = this.$route.query.type
				this.condition.keyValue = this.$route.query.keyValue
				this.getSearchGoods()
			}
		},
		methods: {
			// 获取数据
			getSearchGoods(currentPage){
				let vm = this
				// 区分分页与查询
				if(currentPage){
					vm.paging.currPage = currentPage;
				} else {
					vm.paging.currPage = 1;
				}
				this.axios.get('/api/patent/search/findAllByPage',{params:{
					currPage: vm.paging.currPage,
					everySize: vm.paging.everySize,
					type:vm.condition.type,
					keyValue:vm.condition.keyValue
				}}).then(res => {
					vm.goodsList = res.data.data.goods
					vm.paging = res.data.data.pagingBean
				})
			},
			// 进入商品详情页
			goodsShow(id) {
			    let routeData = this.$router.resolve({
			        path: '/goodsInfo',
			        query: {
			            id: id,
			            mbx: this.mbx,
			            mbxLink: this.mbxLink,
						type:this.condition.type
			        }
			    })
			    window.open(routeData.href, '_blank');
			},
		},
	}
</script>

<style scoped>
	.searchPage{
		background-color: #F8F8F8;
		overflow: hidden;
	}
	.searchContent{
		width: 1200px;
		min-height: 500px;
		background-color: #fff;
		margin: 0 auto;
		margin-top: 20px;
		margin-bottom: 30px;
	}
</style>
